import { SurveyLoadAnswerAction, SurveySaveAnswerAction, SurveySaveDemographicAnswerAction, SurveyActions, SurveyLoadDemographicAnswerAction } from './../action/SurveyActions';
import { SurveyActionTypes, UserActionTypes } from './../action/index';
import { SurveyService } from './../../services/SurveyService';
import { Injectable } from "@angular/core";
import { Actions, Effect } from "@ngrx/effects";
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SurveyEffects {

    constructor(
        private actions: Actions<SurveyActions>,
        private surveyService: SurveyService
    ) {

    }

    @Effect()
    surveyLoadAnswer$ = this.actions.ofType(SurveyActionTypes.SURVEY_LOAD_ANSWER)
        .map((action: SurveyLoadAnswerAction) => action)
        .switchMap(action => this.surveyService.listResultsByUserIdAndAppliedSurvey(action.payload.userId, action.payload.applySurveyId)
            .map(response => ({ type: SurveyActionTypes.SURVEY_LOAD_ANSWER_SUCCESS, answerData: response }))
            .catch(error => Observable.of({ type: SurveyActionTypes.SURVEY_LOAD_ANSWER_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    surveyLoadDemographicAnswer$ = this.actions.ofType(SurveyActionTypes.SURVEY_LOAD_DEMOGRAPHIC_ANSWER)
        .map((action: SurveyLoadDemographicAnswerAction) => action)
        .switchMap(action => this.surveyService.loadDemographicAnswers(action.payload.demograficoId, action.payload.userId)
            .map(response => ({ type: SurveyActionTypes.SURVEY_LOAD_DEMOGRAPHIC_ANSWER_SUCCESS, answerDemographicData: response }))
            .catch(error => Observable.of({ type: SurveyActionTypes.SURVEY_LOAD_DEMOGRAPHIC_ANSWER_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    surveySaveAnswer$ = this.actions.ofType(SurveyActionTypes.SURVEY_SAVE_ANSWER)
        .map((action: SurveySaveAnswerAction) => action)
        .switchMap(action => this.surveyService.saveAnswer(action.payload.answerInfo, action.payload.type)
            .map(response => ({ type: SurveyActionTypes.SURVEY_SAVE_ANSWER_SUCCESS, answerData: response }))
            .catch((error => Observable.of({ type: SurveyActionTypes.SURVEY_SAVE_ANSWER_ERROR, errorPayload: { errorStatus: error.status } })))
        );

    @Effect()
    surveySaveDemographicAnswer$ = this.actions.ofType(SurveyActionTypes.SURVEY_SAVE_DEMOGRAPHIC_ANSWER)
        .map((action: SurveySaveDemographicAnswerAction) => action)
        .switchMap(action => this.surveyService.saveDemographicAnswer(action.payload.answerInfo, action.payload.type)
            .map(response => ({ type: SurveyActionTypes.SURVEY_SAVE_DEMOGRAPHIC_ANSWER_SUCCESS, answerDemographicData: response }))
            .catch(error => Observable.of({ type: SurveyActionTypes.SURVEY_SAVE_DEMOGRAPHIC_ANSWER_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    errorStatus401$ = this.actions
        .map(action => action.errorPayload)
        .filter(payload => payload && (payload.errorStatus === 401 || payload.errorStatus === 0))
        .switchMap(() => Observable.of({ type: UserActionTypes.USER_EXPIRED }));
}


// WEBPACK FOOTER //
// ./src/store/effects/SurveyEffects.ts